import styled from 'styled-components'

export const TopContent = styled.div``

export const CallLogout = styled.div`
  cursor: pointer;
`
